"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.determinePayStatusClassificationByType = void 0;
const enums_1 = require("../enums");
function determinePayStatusClassificationByType(type) {
    if (!type) {
        return 0;
    }
    if (type === enums_1.PayStatusType.AT || type === enums_1.PayStatusType.RPA_OR_MPA) {
        return 1;
    }
    if (type === enums_1.PayStatusType.UTA_OR_RUTA) {
        return 2;
    }
    if (type === enums_1.PayStatusType.FTP || type === enums_1.PayStatusType.GTP) {
        return 3;
    }
    if (type === enums_1.PayStatusType.CIVILIAN) {
        return 4;
    }
    return 0;
}
exports.determinePayStatusClassificationByType = determinePayStatusClassificationByType;
